<template>
  <div class="page-login" v-loading="loading">
    <div class="body">
      <div class="title">{{Config.SYSTEM_TITLE}}</div>
      <form @submit.prevent="doLogin">
        <el-input placeholder="用户名" v-model="form.username" :maxlength="50">
          <i slot="prefix" class="iconfont iconmy"></i>
        </el-input>
        <el-input placeholder="密码" v-model="form.password" type="password" :maxlength="50">
          <i slot="prefix" class="iconfont iconsuo"></i>
        </el-input>
        <!-- <el-checkbox v-model="remember" style="margin-bottom:10px">记住密码</el-checkbox> -->
        <el-button native-type="submit" type="primary" :disabled="!bIsCheck">登录</el-button>
        <div style="margin-top: 10px">
                        <el-checkbox v-model="bIsCheck"
                            >已阅读并同意<a
                                :href="agreementRoute + 'agreement.html'"
                                style="
                                    color: #516690;
                                    text-decoration: underline;
                                    margin: 0 5px;
                                "
                                >用户协议</a
                            >及<a
                                :href="agreementRoute + 'privacy.html'"
                                style="
                                    color: #516690;
                                    text-decoration: underline;
                                    margin: 0 5px;
                                "
                                >隐私政策</a
                            ></el-checkbox
                        >
                    </div>
        
      </form>
    </div>
    <div class="login_footer">
         <p class="text-copyright">
        <span>
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502013857"
            target="_blank"
          >
            <img src="../../assets/police.png" />沪公网安备 31011502013857号
          </a>
        </span>
        &nbsp; &nbsp;
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
          沪ICP备13026006号-5
        </a>
      </p>
        Copyright © 2020 上海恩谷信息科技有限公司. All Rights Reserved.
</div>
  </div>
</template>

<script>
import loginCookie from "@/utils/cookie.js"
export default {
  data() {
    return {
      remember: false,
      loading: false,
      form: {
        username: '',
        password: ''
      },
      // 用户协议
      bIsCheck: false,
     // 丹东使用当地项目的用户协议（非通用版本）
      agreementRoute:"https://static.engoo.cn/files/"
    }
  },
  methods: {
    doLogin() {
      var vm = this
      this.loading = true
      if (vm.remember) {
        let accountInfo = vm.form.username + "&" + vm.form.password;
        loginCookie.setCookie('callCenterInfo', accountInfo, 1440 * 3)
      }
      //没有勾选  删除cookie
      else {
        loginCookie.delCookie('callCenterInfo');
      }
      this.Service.login(this.form.username, this.form.password).then(() => {
        this.routeReplace({ path: '/' })
      }).catch(err => {

        let str = err.data.des;
        if (str == "success" && err.data.userRole != 16) {
          str = "用户权限不足"
        }
        this.$message.error(`${str}`)
      }).finally(() => {
        this.loading = false
      })
    },
    loadAccountInfo() {
      var vm = this;
      let accountInfo = loginCookie.getCookie("callCenterInfo")
      if (Boolean(accountInfo) === false) {
        vm.remember = false
        return false
      }
      else {
        let index = accountInfo.indexOf('&');
        vm.form.username = accountInfo.substring(0, index)
        vm.form.password = accountInfo.substring(index + 1)
        vm.remember = true
      }
    }
  },
  mounted() {
    this.loadAccountInfo()
  }
}
</script>